import React from 'react';
import { stripHasRelatedContent } from '../helpers';
import s from '../Torpedo.scss';
var TorpedoRelatedItem = function (_a) {
    var shouldRenderRelated = _a.shouldRenderRelated, strip = _a.strip;
    if (!shouldRenderRelated || !stripHasRelatedContent(strip)) {
        return null;
    }
    var relatedContent = [];
    var relatedBlockStyle = { clear: 'both' };
    strip.groups.forEach(function (group) {
        return group.items.forEach(function (item) {
            if (!item.dto.renderRelatedContent) {
                return;
            }
            // TODO: it would be useful to pass the in-row position of the rendered item, too
            // we should be able to derive it from the layout...
            relatedContent.push(React.createElement("div", { key: "related-" + item.idx, style: relatedBlockStyle }, item.dto.renderRelatedContent(item)));
        });
    });
    return (React.createElement("div", { key: "row-related-" + strip.idx, className: s['strip'], style: {
            width: strip.width,
        } }, relatedContent));
};
TorpedoRelatedItem.displayName = 'TorpedoRelatedItem';
export default TorpedoRelatedItem;
//# sourceMappingURL=RelatedItem.js.map